import React from 'react'
import ReactDOM from 'react-dom';
import App from './pages/app/App';
import elementTypes from './controls/antd'
import factory from './core/ElementFactory'
import * as serviceWorker from './serviceWorker'
import './index.less'

// 初始化组件列表
factory.registerElement(elementTypes)

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
